import { SET_CURRENT_USER, CLEAR_CURRENT_USER } from "../actions/types";

const initialState = {
  isLoggedIn: false,
  user: {},
};

// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case SET_CURRENT_USER:
      return {
        ...state,
        isLoggedIn: true,
        user: action.payload,
      };
    case CLEAR_CURRENT_USER:
      return {
        ...state,
        isLoggedIn: false,
        user: action.payload,
      };
    default:
      return state;
  }
}
